import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ai-failure',
    templateUrl: './ai-failure.component.html',
    styleUrls: ['./ai-failure.component.scss'],
    standalone: false
})
export class AiFailureComponent {

  constructor(public activeModal: NgbActiveModal) { }

  closeModal() {
    this.activeModal.close();
  }
}
